export default __webpack_public_path__ + "static/media/icons-coins.32171995.svg";